// extracted by mini-css-extract-plugin
export default {"mainWrapper":"MpaAuthUsers_mainWrapper__mOmq9","leftWrapper":"MpaAuthUsers_leftWrapper__SVotA","rightWrapper":"MpaAuthUsers_rightWrapper__JYZkJ"};